import { QueryClient } from '@tanstack/react-query';

import { HttpError } from '../api/errors';

import { HTTP_STATUS } from './constants';
import { PermanentError } from './errors';

const RETRY_COUNT = 2;

export const queryClient = new QueryClient({
  // https://react-query.tanstack.com/reference/QueryClient
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      gcTime: 60_000,
      retry: (failureCount: number, error: unknown) => {
        if (error instanceof HttpError) {
          // Do not retry on 4xx errors and certain server error codes (that will not resolve after a retry)
          if (
            (error.statusCode >= HTTP_STATUS.UNAUTHORIZED &&
              error.statusCode < HTTP_STATUS.INTERNAL_SERVER_ERROR) ||
            [
              HTTP_STATUS.INTERNAL_SERVER_ERROR,
              501,
              505,
              506,
              507,
              508,
              510,
              511,
            ].includes(error.statusCode)
          ) {
            return false;
          }
        } else if (error instanceof PermanentError) {
          return false;
        }

        return failureCount < RETRY_COUNT;
      },
    },
  },
});
